import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function ReceivingAssistantAttentionModal({ open, onClose, onNext }) {
  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ position: "relative" }}>
        <Box display="flex" alignItems="center" justifyContent="center" position="relative">
          <Typography fontSize={24} fontWeight={500} color="text.secondary" align="center">
            Attention
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography fontSize={16} align="center" sx={{ px: 2, py: 1 }}>
          In order to ensure inbound shipments are properly filled out, please go through the
          Receiving Assistant once again.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, justifyContent: "flex-end" }}>
        <Button onClick={onNext} variant="contained" color="primary">
          Next
        </Button>
      </DialogActions>
    </Dialog>
  );
}
